import { BookOpen } from "lucide-react";
import { MARKETING_CONTACT } from "./marketing-content";

export function MarketingFooter() {
  return (
    <footer className="container mx-auto px-4 py-12 border-t">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center space-x-2">
          <BookOpen className="h-6 w-6 text-primary" />
          <span className="text-lg font-semibold">PhiloLMS</span>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-sm text-muted-foreground">
          <a
            href={`mailto:${MARKETING_CONTACT.email}`}
            className="hover:text-foreground transition-colors"
          >
            {MARKETING_CONTACT.email}
          </a>
          <a
            href={`tel:${MARKETING_CONTACT.phoneTel}`}
            className="hover:text-foreground transition-colors"
          >
            {MARKETING_CONTACT.phoneDisplay}
          </a>
          <p>© {new Date().getFullYear()} PhiloLMS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
